// ZoomContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";

const ZoomContext = createContext();

export const ZoomProvider = ({ children }) => {
  const [zoom, setZoom] = useState(1); // session only

  useEffect(() => {
    document.documentElement.style.fontSize = `${zoom * 12}px`;
  }, [zoom]);

  const resetZoom = () => setZoom(1);

  return (
    <ZoomContext.Provider value={{ zoom, setZoom, resetZoom }}>
      {children}
    </ZoomContext.Provider>
  );
};

// Hook
export const useZoom = () => {
  const context = useContext(ZoomContext);
  if (!context) {
    throw new Error("useZoom must be used inside ZoomProvider");
  }
  return context;
};
